import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { NotificationService } from './notification.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  private isAuthenticated = false;
  private resetUserIsRegistered = false;
  private resetUserInfo: any = {};
  systemPasswordChanged = true;
  baseUrl = environment.baseUrl;
  constructor(
    private http: HttpClient,
    private notify: NotificationService,
    private router: Router
  ) {}

  // ---------- OTP FLOW
  setResetInfo(obj: any): void {
    this.resetUserInfo = obj;
    if (this.resetUserInfo) this.resetUserIsRegistered = true;
  }
  getResetInfo(): any {
    // returns info of user who's in the process of resetting password
    return this.resetUserInfo;
  }

  getUserIsRegistered(): any {
    return this.resetUserIsRegistered;
  }
  // -------------OTP FLOW END
  // return if user is logged in
  getIsAuth(): any {
    const token = localStorage.getItem('token') || '';
    return token ? true : false;
  }
  getAuthToken(): any {
    return localStorage.getItem('token') || '';
  }
  getUserInfo(): any {
    return JSON.parse(localStorage.getItem('userInfo') || '{}');
  }
  setIsAuth(status: boolean): any {
    this.isAuthenticated = status;
  }

  saveUserInfo(user: any): any {
    const userInfo = {
      email: user.email,
      firstName: user.firstName,
      lastName: user.lastName,
      middleName: user.middleName,
      hospitalId: user.hospitalId,
      hospitalName: user.hospitalName,
      systemPasswordChanged: user.systemPasswordChanged,
      levelThreeName: user.levelThreeName,
    };
    localStorage.setItem('userInfo', JSON.stringify(userInfo));
  }

  saveAuthData(token: string, refToken: string): any {
    localStorage.setItem('token', token);
    localStorage.setItem('refToken', refToken);
  }
  private storeJwtToken(jwt: string): void {
    localStorage.setItem('token', jwt);
  }

  // API:: login
  login(user: any): any {
    const authData = { userId: user.userId, password: user.password };
    return this.http.post<any>(`${this.baseUrl}/login`, authData, {
      observe: 'response',
    });
  }

  // Refresh Token Api
  refreshToken(): Observable<any> {
    const refToken = localStorage.getItem('refToken') || '';
    return this.http
      .put<any>(
        `${this.baseUrl}/refresh-token`,
        { refreshToken: refToken },
        { observe: 'response' }
      )
      .pipe(
        tap((res: any) => {
          const token = res.headers.get('authorization')?.split(' ')[1];
          const refreshToken = res.headers.get('refreshToken');
          this.saveAuthData(token, refreshToken);
        })
      );
  }

  // API:: Send Otp to Email or Phone
  sendAuthCode(otpObj: object): any {
    return this.http.post<any>(`${this.baseUrl}/send-otp`, otpObj);
  }

  // API:: Validate OTP
  verifyOTP(otpObj: object): any {
    return this.http.post<any>(`${this.baseUrl}/validate-otp`, otpObj, {
      observe: 'response',
    });
  }

  setNewPassword(passwordObj: object): any {
    this.http
      .post<any>(`${this.baseUrl}/forgot-password`, passwordObj)
      .subscribe(
        (res) => {
          this.router.navigate(['/auth/login']);
        },
        (error) => {
          this.notify.openSnackBar(
            'Something went wrong,please try again',
            'close',
            5000
          );
          this.router.navigate(['/auth/reset']);
        }
      );
  }

  changePassword(pwdObj: object): any {
    this.http
      .put<any>(`${this.baseUrl}/user/change-password`, pwdObj)
      .subscribe(
        (res) => {
          this.logout();
          this.router.navigate(['/auth/login']);
        },
        (err) => {
          this.notify.openSnackBar(
            err.error.message ||
              'Something went wrong!, Please contact the administrator',
            'close',
            5000
          );
        }
      );
  }

  logout(): void {
    this.isAuthenticated = false;
    localStorage.clear();
    this.router.navigate(['/auth']);
    this.notify.openSnackBar('Logged out successfully', '', 5000);
  }
}
